import type { PdsPickupChoice } from '../types';

// Une plage telle que `GET /restaurants/:id/schedules/slots` la renvoie pour un jour.
export interface ApiPickupRange {
  openTime: string;
  closeTime: string;
  pickupByRange: boolean;
  orderingClosed: boolean;
  slots: { time: string; available: boolean }[];
}

const QUARTER_MS = 15 * 60_000;

const atTime = (date: string, time: string) =>
  new Date(`${date}T${time}`).getTime();

const timeOf = (timestamp: number) =>
  new Date(timestamp).toLocaleTimeString('fr-BE', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

// Ce que le PDS propose pour un jour : l'heure d'un créneau, ou le début d'une plage servie entière.
// La préparation n'entre pas en compte, le commerçant sait où en est la commande ; seul « maintenant » borne.
// Un créneau complet reste dans la liste, marqué indisponible : le commerçant voit qu'il existe.
export const toPickupChoices = (
  ranges: ApiPickupRange[],
  date: string,
  now: number,
): PdsPickupChoice[] =>
  ranges
    .filter((range) => !range.orderingClosed)
    .flatMap((range): PdsPickupChoice[] => {
      if (!range.pickupByRange) {
        return range.slots
          .map((slot) => ({
            at: atTime(date, slot.time),
            label: slot.time,
            available: slot.available,
          }))
          .filter((choice) => choice.at >= now);
      }
      const close = atTime(date, range.closeTime);
      const start = Math.max(
        atTime(date, range.openTime),
        Math.ceil(now / QUARTER_MS) * QUARTER_MS,
      );
      return start < close
        ? [
            {
              at: start,
              label: `${timeOf(start)}–${range.closeTime}`,
              available: true,
            },
          ]
        : [];
    })
    .sort((a, b) => a.at - b.at);
